/** Readiness band labels for the app-wide 0–150% scale. */
export const READINESS_BANDS = {
  DEVELOPING: "Developing",
  COMPETENT: "Competent",
  EXPERT: "Expert",
};

/**
 * Returns the readiness band for a raw (unsnapped) readiness percentage.
 * Developing: up to and including 50. Competent: above 50 up to and including 100.
 * Expert: above 100. Non-numeric input is treated as 0.
 * @param {number} rawValue - Raw readiness percentage
 * @returns {'Developing'|'Competent'|'Expert'}
 */
export function getReadinessBand(rawValue) {
  const numeric = Number(rawValue);
  const value = Number.isFinite(numeric) ? numeric : 0;

  if (value <= 50) return READINESS_BANDS.DEVELOPING;
  if (value <= 100) return READINESS_BANDS.COMPETENT;
  return READINESS_BANDS.EXPERT;
}
